<div class="p-px-32" *ngIf="!loading">
  <p class="fs-20 fw-700 text-primary">
    Vous pouvez contacter l'agence par messagerie ou par téléphone.
  </p>
  <div class="d-flex">
    <mat-label>Téléphone : </mat-label>
    <p class="ms-3">{{ etablissment?.persons[0]?.numTel || "N/A" }}</p>
  </div>
  <p class="fs-20 fw-700 text-primary">
    Veuillez remplir ce formulaire si vous voulez envoyer un email d'annulation
  </p>
  <app-custom-input
    [parentForm]="form"
    type="text"
    label="Object du mail"
    controlName="emailObject"
    placeholder="Annuler une mission déjà signée"
    [required]="true"
  ></app-custom-input>
  <app-custom-input
    [parentForm]="form"
    controlName="emailBody"
    type="textarea"
    class="pt-px-16"
    label="Corps du mail"
    [placeholder]="
      emailBody
        ? ''
        : 'Bonjour, Je souhaite annuler ma candidature après avoir signé mon contrat'
    "
    [required]="true"
  ></app-custom-input>
  <div class="d-flex justify-content-end align-items-center p-3">
    <app-button
      text="Annuler"
      [stroked]="true"
      (click)="dialogRef.close()"
    ></app-button>
    <app-button
      text="Envoyer"
      (click)="submit()"
      [disabled]="form.invalid"
      class="ms-3"
    ></app-button>
  </div>
</div>

<app-loader *ngIf="loading"></app-loader>
